import React, { useState } from "react";
import "../styles/gallery.css";
import Navbar from "../components/layout/Navbar";
import SeoHead from "../components/SeoHead";

// ── IMAGE DATA ─────────────────────────────────────
// If integrating with App.js, replace these src values with your
// actual base64 image imports (IMG_dr_banner, IMG_wrist, etc.)
const IMAGES = [
  { src: "/images/peripheral&brachial1.jpeg" },
  { src: "/images/peripheral&brachial2.jpeg" },
  { src: "/images/peripheral&brachial3.jpeg" },

  { src: "/images/hand1.jpeg" },
  { src: "/images/hand2.jpeg" },
  { src: "/images/hand3.jpeg" },
  { src: "/images/hand4.jpeg" },
  { src: "/images/hand5.jpeg" },
  { src: "/images/hand6.jpeg" },
  { src: "/images/hand7.jpeg" },
  { src: "/images/hand8.jpeg" },
  { src: "/images/hand9.jpeg" },
  { src: "/images/hand10.jpeg" },
  { src: "/images/hand11.jpeg" },
  { src: "/images/hand12.jpeg" },
  { src: "/images/hand13.jpeg" },

  { src: "/images/wrist1.jpeg" },
  { src: "/images/wrist2.jpeg" },
  { src: "/images/wrist3.jpeg" },
];

// ── VIDEO DATA ─────────────────────────────────────
// For YouTube: use the full watch URL or embed URL. For local videos,
// use src pointing to your .mp4 file, and optionally add a thumb.
const VIDEOS = [
  {
    type: "youtube",
    id: "fJq1rRJvOus",
    title: "Education and Awareness",
    category: "Conference",
  },
  {
    type: "youtube",
    id: "G6_tv8sYCiE",
    title: "Education and Awareness Session",
    category: "Awareness Program",
  },
  {
    type: "youtube",
    id: "Alup-J6NdmY",
    title: "Success Stories",
    category: "Educational",
  },
];

function ytThumb(id) {
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}
function ytEmbed(id) {
  return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
}

export default function Gallerypage() {
  const [tab, setTab] = useState("images"); // 'images' | 'videos'
  const [lightbox, setLightbox] = useState(null);
  const [video, setVideo] = useState(null);

  return (
    <div className="gp-page">

      <SeoHead
        title="Gallery — Hand & Wrist Clinics, Hyderabad"
        description="Surgical case photos, patient outcomes and educational videos from Hand & Wrist Clinics, Hyderabad."
        keywords="hand surgery gallery Hyderabad, hand and wrist clinic gallery, hand surgeon Hyderabad photos, wrist surgery gallery Hyderabad, Dr R Suneel gallery, hand surgery treatment images, microsurgery gallery Hyderabad, hand injury treatment photos, orthopaedic surgeon gallery Hyderabad, Medicover hand surgery gallery, hand and wrist clinic Hyderabad, hand surgery hospital photos"
        url="https://www.handandwristclinics.com/gallery"
      />

      {/* HERO + BREADCRUMB */}
      <header className="gp-hero">
        <div className="gp-hero-inner">
          <nav className="gp-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="gp-bc-sep">/</span>
            <span className="gp-bc-current">Gallery</span>
          </nav>
          <div className="gp-eyebrow">
            <span></span> Our Work in Focus
          </div>
          <h1 className="gp-title">
            Surgical Work & <em>Patient Care</em>
          </h1>
          <div className="gp-divider" />
          <p className="gp-hero-sub">
            A visual record of surgical procedures, patient outcomes, and
            educational content — reflecting our commitment to excellence.
          </p>
        </div>
      </header>

      {/* TABS */}
      <section className="gp-section">
        <div className="gp-container">

          <div className="gp-tabs" role="tablist">
            <button
              role="tab"
              aria-selected={tab === "images"}
              className={`gp-tab ${tab === "images" ? "active" : ""}`}
              onClick={() => setTab("images")}
            >
              <svg className="gp-tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              Images
              <span className="gp-tab-count">{IMAGES.length}</span>
            </button>
            <button
              role="tab"
              aria-selected={tab === "videos"}
              className={`gp-tab ${tab === "videos" ? "active" : ""}`}
              onClick={() => setTab("videos")}
            >
              <svg className="gp-tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="23 7 16 12 23 17 23 7" />
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
              </svg>
              Videos
              <span className="gp-tab-count">{VIDEOS.length}</span>
            </button>
            <div className="gp-tab-indicator" data-pos={tab} />
          </div>

          {/* IMAGES GRID */}
          {tab === "images" && (
            <div className="gp-grid gp-images-grid">
              {IMAGES.map((img, i) => (
                <figure
                  key={i}
                  className={`gp-item ${img.span === 2 ? "gp-wide" : ""}`}
                  onClick={() => setLightbox(img)}
                >
                      <img
                        src={img.src}
                        alt={`Surgical image ${i + 1}`}
                        loading="lazy"
                      />
                  <div className="gp-overlay">
                    <div className="gp-overlay-inner">
                      {img.category && (
                        <span className="gp-cat">{img.category}</span>
                      )}
                      <span className="gp-label">{img.label}</span>
                    </div>
                    <div className="gp-zoom-icon" aria-hidden>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        <line x1="11" y1="8" x2="11" y2="14" />
                        <line x1="8" y1="11" x2="14" y2="11" />
                      </svg>
                    </div>
                  </div>
                </figure>
              ))}
            </div>
          )}

          {/* VIDEOS GRID */}
          {tab === "videos" && (
            <div className="gp-grid gp-videos-grid">
              {VIDEOS.map((v, i) => (
                <article
                  key={i}
                  className="gp-video-item"
                  onClick={() => setVideo(v)}
                >
                  <div className="gp-video-thumb">
                    <img
                      src={v.thumb || ytThumb(v.id)}
                      alt={v.title}
                      loading="lazy"
                    />
                    <div className="gp-video-overlay">
                      <button className="gp-play-btn" aria-label={`Play ${v.title}`}>
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </button>
                    </div>
                    {v.duration && (
                      <span className="gp-video-duration">{v.duration}</span>
                    )}
                  </div>
                  <div className="gp-video-meta">
                    {v.category && (
                      <span className="gp-cat gp-cat-video">{v.category}</span>
                    )}
                    <h3 className="gp-video-title">{v.title}</h3>
                  </div>
                </article>
              ))}
            </div>
          )}

        </div>
      </section>

      {/* IMAGE LIGHTBOX */}
      {lightbox && (
        <div className="gp-lightbox" onClick={() => setLightbox(null)}>
          <button
            className="gp-lb-close"
            onClick={(e) => { e.stopPropagation(); setLightbox(null); }}
            aria-label="Close"
          >
            ✕
          </button>
          <img
            className="gp-lb-img"
            src={lightbox.src}
            alt={lightbox.label}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="gp-lb-caption">
            {lightbox.category && <span>{lightbox.category}</span>}
            <h4>{lightbox.label}</h4>
          </div>
        </div>
      )}

      {/* VIDEO MODAL */}
      {video && (
        <div className="gp-lightbox gp-video-modal" onClick={() => setVideo(null)}>
          <button
            className="gp-lb-close"
            onClick={(e) => { e.stopPropagation(); setVideo(null); }}
            aria-label="Close"
          >
            ✕
          </button>
          <div
            className="gp-video-frame"
            onClick={(e) => e.stopPropagation()}
          >
            {video.type === "youtube" ? (
              <iframe
                src={ytEmbed(video.id)}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <video src={video.src} controls autoPlay>
                Your browser does not support the video tag.
              </video>
            )}
          </div>
          <div className="gp-lb-caption">
            {video.category && <span>{video.category}</span>}
            <h4>{video.title}</h4>
          </div>
        </div>
      )}

      
    </div>
  );
}